// extracted by mini-css-extract-plugin
module.exports = {"stats":"CardStats_stats__0hFtI","stats__item":"CardStats_stats__item__SSNQK"};